export type Theme = 'light' | 'dark' | 'system';

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === 'dark') {
    root.classList.add('dark');
    root.classList.remove('light');
    root.setAttribute('data-theme', 'dark');
  } else if (theme === 'light') {
    root.classList.add('light');
    root.classList.remove('dark');
    root.setAttribute('data-theme', 'light');
  } else {
    root.classList.remove('dark', 'light');
    root.removeAttribute('data-theme');
  }
}

export function detectSystemTheme(): 'light' | 'dark' {
  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
}

export function initTheme(): void {
  const saved = localStorage.getItem('trilirivos-theme') as Theme | null;
  const theme = saved || 'system';

  if (theme === 'system') {
    const systemTheme = detectSystemTheme();
    applyTheme(systemTheme);
  } else {
    applyTheme(theme);
  }

  window
    .matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', (e) => {
      const currentTheme = (localStorage.getItem('trilirivos-theme') ||
        'system') as Theme;
      if (currentTheme === 'system') {
        applyTheme(e.matches ? 'dark' : 'light');
      }
    });
}

export function setTheme(theme: Theme): void {
  localStorage.setItem('trilirivos-theme', theme);
  if (theme === 'system') {
    applyTheme(detectSystemTheme());
  } else {
    applyTheme(theme);
  }
}
